import React from "react";
import styles from "../../styles/SpecialServices.module.css"; // adjust the path
import { FaCogs, FaUsers, FaChartLine, FaHandsHelping } from "react-icons/fa";

const servicesData = [
    {
      icon: <FaCogs />,
      title: "PROJECT DEVELOPMENT FOR FUNDING",
      points: [
        "Transform your innovative ideas into compelling proposals.",
        "Leverage our strategic planning and expert guidance to secure grants and competitive bids.",
      ],
    },
    {
      icon: <FaUsers />,
      title: "PROJECT MANAGEMENT FOR SUSTAINABILITY",
      points: [
        "Enjoy end-to-end project execution with a focus on quality and efficiency.",
        "Benefit from our rigorous planning, financial management, and reporting systems to ensure success.",
      ],
    },
    {
      icon: <FaChartLine />,
      title: "EVALUATION & IMPACT ASSESSMENT",
      points: [
        "Receive detailed evaluations that measure outcomes and drive continuous improvement.",
        "Implement results-based management to achieve tangible impact.",
      ],
    },
    {
      icon: <FaHandsHelping />,
      title: "CAPACITY BUILDING",
      points: [
        "Empower your organization through tailored training and technical support.",
        "Build long-term resilience and sustainable growth with our expertise.",
      ],
    },
  ];

const SpecialServices = () => {
  return (
    <section className={styles.servicesSection}>
      <h4 className={styles.subtitle}>— Explore Our Expertise</h4>
      <h2 className={styles.title}>HOW WE DO</h2>
      <div className={styles.cards}>
        {servicesData.map((service, index) => (
          <div
            key={service.id}
            className={`${styles.card} ${index === 0 ? styles.active : ""}`}
          >
            <div 
                style={{
                    borderBottom: `1px solid ${index === 0 ? 'rgba(255,255,255,0.5)' : '#ccc'}`,
                }}
            >
                <div className={styles.icon} style={{color:`${index !== 0 ? '#003366' : ''}`}}>{service.icon}</div>
                <div className={styles.number} style={{color:`${index !== 0 ? '#003366' : ''}`}}>{`0${index+1}`}</div>
            </div>
            <div>
                <h3 style={{color:`${index !== 0 ? '#003366' : 'white'}`,fontSize:'15px'}}>{service.title}</h3>
                <p style={{color:`${index !== 0 ? '#999' : ''}`}}>
                    {service.points}
                </p>
            </div>
            <div
                style={{
                    borderTop: `1px solid ${index === 0 ? 'rgba(255,255,255,0.5)' : '#ccc'}`,
                }}
            >
                {/* <span className={styles.readMore} style={{color:`${index !== 0 ? '#003366' : ''}`}}>Read More →</span> */}
            </div>
          </div>
        ))}
      </div>
      {/* <button className={styles.viewAll}>VIEW ALL →</button> */}
    </section>
  );
};

export default SpecialServices;
